/**
 * Top Link Product Pinning Feature
 * 将指定ID的商品固定到集合页面的第一排第一个位置，并保留原有动画效果
 */

// 配置常量
const CONFIG = {
  TARGET_DOMAIN: 'www.truegemstone.com',
  CONTAINER_SELECTORS: ['#data-pagination'],
  MAX_RETRY_ATTEMPTS: 3,
  RETRY_INTERVAL_MS: 150
};

/**
 * 从URL中获取指定参数的值
 * @param {string} paramName - 要获取的参数名
 * @returns {string|null} 参数值，如果不存在则返回null
 */
function getUrlParam(paramName) {
  const url = new URL(window.location.href);
  return url.searchParams.get(paramName);
}

/**
 * 查找商品列表容器
 * @returns {HTMLElement|null} 商品列表容器
 */
function findProductListContainer() {
  // 尝试通过配置的选择器查找容器
  for (const selector of CONFIG.CONTAINER_SELECTORS) {
    const container = document.querySelector(selector);
    if (container) {
      return container;
    }
  }
  return null;
}

/**
 * 查找指定ID的商品元素
 * @param {string} productId - 商品ID
 * @returns {HTMLElement|null} 商品元素
 */
function findProductElement(productId) {
  // 支持带有前缀的ID格式
  const fullId = productId.startsWith('product-card__') ? productId : `product-card__${productId}`;
  return document.getElementById(fullId) || 
         document.querySelector(`[id*="${productId}"]`);
}

/**
 * 将商品元素移动到容器的最前面
 * @param {HTMLElement} productElement - 商品元素
 * @param {HTMLElement} container - 商品列表容器
 */
function moveProductToFront(productElement, container) {
  if (!productElement || !container) return;
  
  // 找到商品元素的父元素 (li.grid__item)
  const productItem = productElement.closest('.grid__item');
  if (!productItem) return;
  
  // 保留原始的样式和类
  const originalClasses = productItem.className;
  const originalStyles = productItem.getAttribute('style') || '';
  
  // 克隆商品项，这样可以保留所有事件监听器和数据
  const clonedItem = productItem.cloneNode(true);
  
  // 移除原始商品项
  productItem.parentNode.removeChild(productItem);
  
  // 检查是否有促销卡片在第一位
  const firstChild = container.firstChild;
  let insertPosition = container.firstChild;
  
  // 查找第一个非促销卡片的位置
  while (insertPosition && insertPosition.nodeType === 1 && 
         (insertPosition.classList.contains('promotion-card') || 
          insertPosition.querySelector('.promotion-card'))) {
    insertPosition = insertPosition.nextSibling;
  }
  
  // 将克隆的商品项插入到容器的最前面（或第一个非促销卡片前）
  if (insertPosition && insertPosition !== container.firstChild) {
    container.insertBefore(clonedItem, insertPosition);
  } else {
    container.insertBefore(clonedItem, container.firstChild);
  }
  
  // 添加动画效果
  setTimeout(() => {
    clonedItem.style.opacity = '0.6';
    clonedItem.style.transform = 'scale(0.95)';
    
    setTimeout(() => {
      clonedItem.style.opacity = '1';
      clonedItem.style.transform = 'scale(1)';
    }, 200);
  }, 50);
}

/**
 * 尝试将指定ID的商品置顶
 * @param {string} productId - 商品ID
 * @param {number} attempt - 当前尝试次数
 */
function tryPinProduct(productId, attempt = 0) {
  // 查找商品元素和容器
  const productElement = findProductElement(productId);
  const container = findProductListContainer();
  
  if (productElement && container) {
    // 将商品移动到最前面
    moveProductToFront(productElement, container);
  } else if (attempt < CONFIG.MAX_RETRY_ATTEMPTS) {
    // 如果未找到商品元素或容器，且未达到最大重试次数，则重试
    setTimeout(() => {
      tryPinProduct(productId, attempt + 1);
    }, CONFIG.RETRY_INTERVAL_MS);
  }
}

/**
 * 检查URL并执行商品置顶逻辑
 */
function pinProductToTop() {
  // 获取URL中的商品ID参数
  const productId = getUrlParam('id');
  
  // 检查是否是集合页面且有商品ID参数
  const isCollectionPage = window.location.href.includes(CONFIG.TARGET_DOMAIN + '/collections/') || 
                          window.location.href.includes('/collections/');
  
  if (isCollectionPage && productId) {
    // 等待DOM完全加载后执行，确保所有商品都已渲染
    if (document.readyState === 'complete') {
      tryPinProduct(productId);
    } else {
      window.addEventListener('load', () => tryPinProduct(productId));
    }
  }
}

/**
 * 初始化商品置顶功能
 */
function initProductPinFeature() {
  // 页面加载后执行商品置顶逻辑
  pinProductToTop();
  
  // 监听浏览器历史状态变化（如前进后退按钮）
  window.addEventListener('popstate', pinProductToTop);
}

/**
 * 监听页面上所有链接的点击事件，处理带id参数的链接
 */
function setupLinkClickListener() {
  document.addEventListener('click', function(event) {
    const target = event.target.closest('a');
    
    if (!target) return;
    
    const href = target.getAttribute('href');
    
    // 检查是否是集合页面链接且包含id参数
    if (href && 
        (href.includes('/collections/') || 
         href.includes(CONFIG.TARGET_DOMAIN + '/collections/')) && 
        href.includes('?id=')) {
      // 链接已处理，让浏览器正常跳转
      // 页面加载后的逻辑会在目标页面执行商品置顶
    }
  });
}

// 当DOM加载完成时初始化功能
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initProductPinFeature();
    setupLinkClickListener();
  });
} else {
  // 如果DOM已经加载完成，直接初始化
  initProductPinFeature();
  setupLinkClickListener();
}